import { useQuery } from "react-query";
import { TGetServiceHolderResponse } from "../../api/serviceHolder/apiGetServiceHolder";
import {
  apiGetServiceHolders,
  IApiGetServiceHolders,
} from "../../api/serviceHolder/apiGetServiceHolders";

export default function useServiceHolderUniqueCifQuery(
  cif: string,
  enabled = true
) {
  return useQuery(
    ["service-holders/find_unique_cif", cif],
    async () => {
      const params: IApiGetServiceHolders = {
        page: 1,
        itemsPerPage: 10,
        searchFor: cif,
      };

      let res = await apiGetServiceHolders(params);

      return (res["hydra:member"] as TGetServiceHolderResponse[]).filter(
        (serviceHolder) =>
          serviceHolder.DNI_U1 === cif || serviceHolder.DNI_U2 === cif
      );
    },
    {
      enabled: enabled ? cif !== "" : false,
    }
  );
}
